import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import BuildIcon from "@mui/icons-material/Build";
import ScheduleIcon from "@mui/icons-material/Schedule";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";

import EngineeringIcon from "@mui/icons-material/Engineering";
import BusinessIcon from "@mui/icons-material/Business";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import GroupsIcon from "@mui/icons-material/Groups";

export const whyChooseUs = [
    {
        text: "Over 10 years of experience",
        icon: <WorkspacePremiumIcon />,
    },
    {
        text: "High-quality construction & materials",
        icon: <BuildIcon />,
    },
    {
        text: "On-time project delivery",
        icon: <ScheduleIcon />,
    },
    {
        text: "Professional and certified team",
        icon: <VerifiedUserIcon />,
    },
    {
        text: "Customer satisfaction guaranteed",
        icon: <ThumbUpAltIcon />,
    },
];

export const aboutStats = [
    {
        label: "Projects Completed",
        value: "200+",
        icon: EngineeringIcon,
    },
    {
        label: "Ongoing Projects",
        value: "40+",
        icon: BusinessIcon,
    },
    {
        label: "Site Engineers",
        value: "40",
        icon: GroupsIcon,
    },
    {
        label: "Years Experience",
        value: "15",
        icon: EmojiEventsIcon,
    },
];

export const teamMembers = [
    {
        name: "John Doe",
        role: "Founder & CEO",
        image: "https://via.placeholder.com/150",
        bio: "15 years of experience in structural engineering and construction management.",
    },
    {
        name: "Jane Smith",
        role: "Lead Architect",
        image: "https://via.placeholder.com/150",
        bio: "Award-winning architect specializing in sustainable and modern residential designs.",
    },
    {
        name: "Mike Johnson",
        role: "Project Manager",
        image: "https://via.placeholder.com/150",
        bio: "Expert in project execution and on-site management ensuring timely delivery.",
    },
];

